// components
import { Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

// styles
import { StyledEmptyFeedbackBox } from './SpecialLeaveTab.styles';
import { useTranslation } from 'react-i18next';
import { SpecialLeaveTableProps } from './SpecialLeaveTable.types';

// motion component
import { MotionSlideUpPositionIn } from './SpecialLeaveTable.motion';

const SpecialLeaveTable = ({
  specialLeavesRows,
  columns,
  isEditable,
  handleDeleteRows,
  handleEditNominalDuty
}: SpecialLeaveTableProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.specialLeave.settings'
  });

  return (
    <>
      {specialLeavesRows && specialLeavesRows?.length > 0 ? (
        <MotionSlideUpPositionIn
          key="motion-special-leave-tab-table"
          layout="position"
        >
          <TableCRUDLayout
            shouldRenderToolBar={false}
            rows={specialLeavesRows}
            getRowId={(row) => row.special_leave_id}
            columns={columns}
            loading={false}
            disableActions={!isEditable}
            onDeleteClick={handleDeleteRows}
            confirmationTitle={t('deleteDialog.title')}
            confirmationBody={t('deleteDialog.body')}
            hideCreateAction
            editable={false}
            onEditClick={(id, row) => handleEditNominalDuty({ id, row })}
          />
        </MotionSlideUpPositionIn>
      ) : (
        <MotionSlideUpPositionIn
          key="motion-special-leave-tab-empty"
          layout="position"
        >
          <StyledEmptyFeedbackBox isEditable={isEditable}>
            <Icon type="tree-palm" color="primary" fontSize="inherit" />
            <Typography variant="h6">{t('noSpecialLeavesAdded')}</Typography>
          </StyledEmptyFeedbackBox>
        </MotionSlideUpPositionIn>
      )}
    </>
  );
};

export default SpecialLeaveTable;
